import type { ApiClient } from './runtime/apiRuntime';
import { apiMutationOptions, BaseApiMutationOptions } from './apiMutationOptions';
import { apiQueryOptions, BaseApiQueryOptions } from './apiQueryOptions';

export const ChatLinkSecurityApi = {
    get: (options?: BaseApiQueryOptions) => apiQueryOptions(['chatLinkSecurity', 'get'], (api) => api.chatLinkSecurity.get(), options),
    update: (options?: BaseApiMutationOptions<ApiClient['chatLinkSecurity']['update']>) => apiMutationOptions((api) => api.chatLinkSecurity.update, options)
};
